import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import Contact from "@/pages/Contact";
import LogoTypes from "@/pages/LogoTypes";
import BusinessCards from "@/pages/BusinessCards";
import CommissionPortraits from "@/pages/CommissionPortraits";
import ComicBooks from "@/pages/ComicBooks";
import ChildrensBooks from "@/pages/ChildrensBooks";
import CustomIllustrations from "@/pages/CustomIllustrations";
import AbstractArt from "@/pages/AbstractArt";
import SpecialProjects from "@/pages/SpecialProjects";
import CheckoutSuccess from "@/pages/CheckoutSuccess";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/logo-types" element={<LogoTypes />} />
          <Route path="/business-cards" element={<BusinessCards />} />
          <Route path="/commission-portraits" element={<CommissionPortraits />} />
          <Route path="/comic-books" element={<ComicBooks />} />
          <Route path="/childrens-books" element={<ChildrensBooks />} />
          <Route path="/custom-illustrations" element={<CustomIllustrations />} />
          <Route path="/abstract-art" element={<AbstractArt />} />
          <Route path="/special-projects" element={<SpecialProjects />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
